export const SALUTATIONS_GERMAN = [
  {
    title: "Herr",
    value: "MR",
  },
  {
    title: "Frau",
    value: "MRS",
  },
  {
    title: "Divers",
    value: "OTHER",
  },
];

export const SALUTATIONS = [
  {
    title: "Mr",
    value: "MR",
  },
  {
    title: "Mrs",
    value: "MRS",
  },
  {
    title: "Diverse",
    value: "OTHER",
  },
];

export const PROJECT_STATUS_GERMAN = [
  {
    title: "In planning ",
    value: "PLANNED",
  },
  {
    title: "In execution ",
    value: "UNDER_CONSTRUCTION",
  },
  {
    title: "Commissioned",
    value: "DONE",
  },
];

export const PROJECT_STATUS = [
  {
    title: "In Planung",
    value: "PLANNED",
  },
  {
    title: "In Umsetzung",
    value: "UNDER_CONSTRUCTION",
  },
  {
    title: "Fertiggestellt",
    value: "DONE",
  },
];

export const EXPERIENCE = [
  {
    title: "Anfänger",
    value: "BEGINNER",
  },
  {
    title: "Fortgeschritten",
    value: "INTERMEDIATE",
  },
  {
    title: "Experte",
    value: "EXPERT",
  },
];

export const DEPARTMENTS_GERMAN = [
  {
    title: "Forschung & Entwicklung",
    value: "RESEARCH_AND_DEVELOPMENT",
  },
  {
    title: "Vertrieb",
    value: "SALES",
  },
  {
    title: "Projektmanagement",
    value: "PROJECT_MANAGEMENT",
  },
  {
    title: "Service",
    value: "SERVICE",
  },
  {
    title: "Verwaltung",
    value: "ADMINISTRATION",
  },
  {
    title: "Produktion",
    value: "PRODUCTION",
  },
  {
    title: "Logistik",
    value: "LOGISTICS",
  },
  {
    title: "IT",
    value: "IT",
  },
  {
    title: "Weiteres",
    value: "OTHER",
  },
];

export const DEPARTMENTS = [
  {
    title: "Research & Development",
    value: "RESEARCH_AND_DEVELOPMENT",
  },
  {
    title: "Sales",
    value: "SALES",
  },
  {
    title: "Project Management",
    value: "PROJECT_MANAGEMENT",
  },
  {
    title: "Service",
    value: "SERVICE",
  },
  {
    title: "Administration",
    value: "ADMINISTRATION",
  },
  {
    title: "Production",
    value: "PRODUCTION",
  },
  {
    title: "Logistics",
    value: "LOGISTICS",
  },
  {
    title: "IT",
    value: "IT",
  },
  {
    title: "Others",
    value: "OTHER",
  },
];

export const CHANNELS_GERMAN = [
  {
    title: "Messen/Veranstaltungen",
    value: "EVENT",
  },
  {
    title: "Familie/Bekannte",
    value: "ACQUAINTANCE",
  },
  {
    title: "Instagram",
    value: "INSTAGRAM",
  },
  {
    title: "LinkedIn",
    value: "LINKEDIN",
  },
  {
    title: "Anzeigen",
    value: "ADVERTISEMENT",
  },
  {
    title: "Webseite",
    value: "WEBSITE",
  },
  {
    title: "Jobportale",
    value: "JOB_PORTAL",
  },
  {
    title: "Sonstiges",
    value: "OTHER",
  },
];

export const CHANNELS = [
  {
    title: "Trade fair/evens",
    value: "EVENT",
  },
  {
    title: "Family/friends",
    value: "ACQUAINTANCE",
  },
  {
    title: "Instagram",
    value: "INSTAGRAM",
  },
  {
    title: "LinkedIn",
    value: "LINKEDIN",
  },
  {
    title: "Advertisement",
    value: "ADVERTISEMENT",
  },
  {
    title: "Website",
    value: "WEBSITE",
  },
  {
    title: "Jobportals",
    value: "JOB_PORTAL",
  },
  {
    title: "Sonstiges",
    value: "OTHER",
  },
];

export const DISTRIBUTIONS_REGIONS_GERMAN = [
  {
    title: "Baltikum",
    value: "LT",
  },
  {
    title: "Belgien",
    value: "BE",
  },
  {
    title: "Chile",
    value: "CL",
  },
  {
    title: "Deutschland",
    value: "DE",
  },
  {
    title: "Frankreich",
    value: "FR",
  },
  {
    title: "Griechenland",
    value: "GR",
  },
  {
    title: "Großbritannien",
    value: "GB",
  },
  {
    title: "Irland",
    value: "IE",
  },
  {
    title: "Italien",
    value: "IT",
  },
  {
    title: "Japan",
    value: "JP",
  },
  {
    title: "Kanada",
    value: "CA",
  },
  {
    title: "Niederlande",
    value: "NL",
  },
  {
    title: "Österreich",
    value: "AT",
  },
  {
    title: "Polen",
    value: "PL",
  },
  {
    title: "Portugal",
    value: "PT",
  },
  {
    title: "Rumänien",
    value: "RO",
  },
  {
    title: "Skandinavien",
    value: "FI",
  },
  {
    title: "Spanien",
    value: "ES",
  },
  {
    title: "Türkei",
    value: "TR",
  },
  {
    title: "Vietnam",
    value: "VN",
  },
  {
    title: "Andere Länder",
    value: "OTHER",
  },
];

export const DISTRIBUTIONS_REGIONS = [
  {
    title: "Baltic states",
    value: "LT",
  },
  {
    title: "Belgium",
    value: "BE",
  },
  {
    title: "Chile",
    value: "CL",
  },
  {
    title: "Germany",
    value: "DE",
  },
  {
    title: "France",
    value: "FR",
  },
  {
    title: "Greece",
    value: "GR",
  },
  {
    title: "United Kingdom",
    value: "GB",
  },
  {
    title: "Ireland",
    value: "IE",
  },
  {
    title: "Italy",
    value: "IT",
  },
  {
    title: "Japan",
    value: "JP",
  },
  {
    title: "Kanada",
    value: "CA",
  },
  {
    title: "Netherlands",
    value: "NL",
  },
  {
    title: "Austria",
    value: "AT",
  },
  {
    title: "Poland",
    value: "PL",
  },
  {
    title: "Portugal",
    value: "PT",
  },
  {
    title: "Romania",
    value: "RO",
  },
  {
    title: "Scandinavia",
    value: "FI",
  },
  {
    title: "Spain ",
    value: "ES",
  },
  {
    title: "Türkiye",
    value: "TR",
  },
  {
    title: "Vietnam",
    value: "VN",
  },
  {
    title: "Other country",
    value: "OTHER",
  },
];

export const backendLanguageValues = {
  LT: "BALTIC_STATES",
  BE: "BELGIUM",
  CL: "CHILE",
  DE: "GERMANY",
  FR: "FRANCE",
  GR: "GREECE",
  GB: "GREAT_BRITAIN",
  IE: "IRELAND",
  IT: "ITALY",
  JP: "JAPAN",
  CA: "CANADA",
  NL: "NETHERLANDS",
  AT: "AUSTRIA",
  PL: "POLAND",
  PT: "PORTUGAL",
  RO: "ROMANIA",
  FI: "SKANDINAVIA",
  ES: "SPAIN",
  TR: "TURKEY",
  VN: "VIETNAM",
};

export const COUNTRIES_GERMAN = [
  {
    title: "Afghanistan",
    value: "AF",
  },
  {
    title: "Albanien",
    value: "AL",
  },
  {
    title: "Algerien",
    value: "DZ",
  },
  {
    title: "Amerikanisch Samoa",
    value: "AS",
  },
  {
    title: "Andorra",
    value: "AD",
  },
  {
    title: "Angola",
    value: "AO",
  },
  {
    title: "Anguilla",
    value: "AI",
  },
  {
    title: "Argentinien",
    value: "AR",
  },
  {
    title: "Armenien",
    value: "AM",
  },
  {
    title: "Aruba",
    value: "AW",
  },
  {
    title: "Australien",
    value: "AU",
  },
  {
    title: "Azerbaijan",
    value: "AZ",
  },
  {
    title: "Bahamas",
    value: "BS",
  },
  {
    title: "Bahrain",
    value: "BH",
  },
  {
    title: "Bangladesch",
    value: "BD",
  },
  {
    title: "Barbados",
    value: "BB",
  },
  {
    title: "Belarus",
    value: "BY",
  },
  {
    title: "Belgien",
    value: "BE",
  },
  {
    title: "Belize",
    value: "BZ",
  },
  {
    title: "Benin",
    value: "BJ",
  },
  {
    title: "Bermuda",
    value: "BM",
  },
  {
    title: "Bhutan",
    value: "BT",
  },
  {
    title: "Bolivien",
    value: "BO",
  },
  {
    title: "Bosnien und Herzegowina",
    value: "BA",
  },
  {
    title: "Botsuana",
    value: "BW",
  },
  {
    title: "Brazilien",
    value: "BR",
  },
  {
    title: "Britische Jungferninseln",
    value: "VG",
  },
  {
    title: "Brunei",
    value: "BN",
  },
  {
    title: "Bulgarien",
    value: "BG",
  },
  {
    title: "Burkina Faso",
    value: "BF",
  },
  {
    title: "Burundi",
    value: "BI",
  },
  {
    title: "Cambodia",
    value: "KH",
  },
  {
    title: "Cameroon",
    value: "CM",
  },
  {
    title: "Kanada",
    value: "CA",
  },
  {
    title: "Kap Verde",
    value: "CV",
  },
  {
    title: "Kaimaninseln",
    value: "KY",
  },
  {
    title: "Zentralafrikanische Republik",
    value: "CF",
  },
  {
    title: "Tschad",
    value: "TD",
  },
  {
    title: "Chile",
    value: "CL",
  },
  {
    title: "China",
    value: "CN",
  },
  {
    title: "Kolumbien",
    value: "CO",
  },
  {
    title: "Komoren",
    value: "KM",
  },
  {
    title: "Cookinseln",
    value: "CK",
  },
  {
    title: "Costa Rica",
    value: "CR",
  },
  {
    title: "Kroatien",
    value: "HR",
  },
  {
    title: "Kuba",
    value: "CU",
  },
  {
    title: "Curaçao",
    value: "CW",
  },
  {
    title: "Zypern",
    value: "CY",
  },
  {
    title: "Tschechien",
    value: "CZ",
  },
  {
    title: "Demokratische Republik Kongo",
    value: "CD",
  },
  {
    title: "Dänemark",
    value: "DK",
  },
  {
    title: "Dschibuti",
    value: "DJ",
  },
  {
    title: "Dominica",
    value: "DM",
  },
  {
    title: "Dominikanische Republik",
    value: "DO",
  },
  {
    title: "Osttimor",
    value: "TL",
  },
  {
    title: "Ecuador",
    value: "EC",
  },
  {
    title: "Ägypten",
    value: "EG",
  },
  {
    title: "El Salvador",
    value: "SV",
  },
  {
    title: "Eritrea",
    value: "ER",
  },
  {
    title: "Estland",
    value: "EE",
  },
  {
    title: "Färöer",
    value: "FO",
  },
  {
    title: "Fidschi",
    value: "FJ",
  },
  {
    title: "Finnland",
    value: "FI",
  },
  {
    title: "Frankreich",
    value: "FR",
  },
  {
    title: "Französisch-Polynesien",
    value: "PF",
  },
  {
    title: "Gabun",
    value: "GA",
  },
  {
    title: "Gambia",
    value: "GM",
  },
  {
    title: "Georgien",
    value: "GE",
  },
  {
    title: "Deutschland",
    value: "DE",
  },
  {
    title: "Ghana",
    value: "GH",
  },
  {
    title: "Griechenland",
    value: "GR",
  },
  {
    title: "Grönland",
    value: "GL",
  },
  {
    title: "Grenada",
    value: "GD",
  },
  {
    title: "Guam",
    value: "GU",
  },
  {
    title: "Guatemala",
    value: "GT",
  },
  {
    title: "Guernsey",
    value: "GG",
  },
  {
    title: "Guinea",
    value: "GN",
  },
  {
    title: "Guinea-Bissau",
    value: "GW",
  },
  {
    title: "Guyana",
    value: "GY",
  },
  {
    title: "Haiti",
    value: "HT",
  },
  {
    title: "Honduras",
    value: "HN",
  },
  {
    title: "Hong Kong",
    value: "HK",
  },
  {
    title: "Ungarn",
    value: "HU",
  },
  {
    title: "Island",
    value: "IS",
  },
  {
    title: "Indien",
    value: "IN",
  },
  {
    title: "Indonesien",
    value: "ID",
  },
  {
    title: "Iran",
    value: "IR",
  },
  {
    title: "Iraq",
    value: "IQ",
  },
  {
    title: "Irland",
    value: "IE",
  },
  {
    title: "Isle of Man",
    value: "IM",
  },
  {
    title: "Israel",
    value: "IL",
  },
  {
    title: "Italien",
    value: "IT",
  },
  {
    title: "Elfenbeinküste",
    value: "CI",
  },
  {
    title: "Jamaika",
    value: "JM",
  },
  {
    title: "Japan",
    value: "JP",
  },
  {
    title: "Jersey",
    value: "JE",
  },
  {
    title: "Jordanien",
    value: "JO",
  },
  {
    title: "Kasachstan",
    value: "KZ",
  },
  {
    title: "Kenia",
    value: "KE",
  },
  {
    title: "Kiribati",
    value: "KI",
  },
  {
    title: "Kosovo",
    value: "XK",
  },
  {
    title: "Kuwait",
    value: "KW",
  },
  {
    title: "Kirgisistan",
    value: "KG",
  },
  {
    title: "Laos",
    value: "LA",
  },
  {
    title: "Lettland",
    value: "LV",
  },
  {
    title: "Libanon",
    value: "LB",
  },
  {
    title: "Lesotho",
    value: "LS",
  },
  {
    title: "Liberia",
    value: "LB",
  },
  {
    title: "Libyen",
    value: "LY",
  },
  {
    title: "Liechtenstein",
    value: "LI",
  },
  {
    title: "Litauen",
    value: "LT",
  },
  {
    title: "Luxemburg",
    value: "LU",
  },
  {
    title: "Macau",
    value: "MO",
  },
  {
    title: "Mazedonien",
    value: "MK",
  },
  {
    title: "Madagaskar",
    value: "MG",
  },
  {
    title: "Malawi",
    value: "MW",
  },
  {
    title: "Malaysia",
    value: "MY",
  },
  {
    title: "Malediven",
    value: "MV",
  },
  {
    title: "Mali",
    value: "ML",
  },
  {
    title: "Malta",
    value: "MT",
  },
  {
    title: "Marshallinseln",
    value: "MH",
  },
  {
    title: "Mauretanien",
    value: "MR",
  },
  {
    title: "Mauritius",
    value: "MU",
  },
  {
    title: "Mayotte",
    value: "YT",
  },
  {
    title: "Mexiko",
    value: "MX",
  },
  {
    title: "Föderierte Staaten von Mikronesien",
    value: "FM",
  },
  {
    title: "Moldawien",
    value: "MD",
  },
  {
    title: "Monaco",
    value: "MC",
  },
  {
    title: "Mongolei",
    value: "MN",
  },
  {
    title: "Montenegro",
    value: "ME",
  },
  {
    title: "Marokko",
    value: "MA",
  },
  {
    title: "Mosambik",
    value: "MZ",
  },
  {
    title: "Myanmar",
    value: "MM",
  },
  {
    title: "Namibia",
    value: "NA",
  },
  {
    title: "Nepal",
    value: "NP",
  },
  {
    title: "Niederlande",
    value: "NL",
  },
  {
    title: "Neukaledonien",
    value: "NC",
  },
  {
    title: "Neuseeland",
    value: "NZ",
  },
  {
    title: "Nicaragua",
    value: "NI",
  },
  {
    title: "Niger",
    value: "NE",
  },
  {
    title: "Nigeria",
    value: "NG",
  },
  {
    title: "Nordkorea",
    value: "KP",
  },
  {
    title: "Nördliche Marianen",
    value: "MP",
  },
  {
    title: "Norwegen",
    value: "NO",
  },
  {
    title: "Oman",
    value: "OM",
  },
  {
    title: "Pakistan",
    value: "PK",
  },
  {
    title: "Palästina",
    value: "PS",
  },
  {
    title: "Panama",
    value: "PA",
  },
  {
    title: "Papua-Neuguinea",
    value: "PG",
  },
  {
    title: "Paraguay",
    value: "PY",
  },
  {
    title: "Peru",
    value: "PE",
  },
  {
    title: "Philippinen",
    value: "PH",
  },
  {
    title: "Polen",
    value: "PL",
  },
  {
    title: "Portugal",
    value: "PT",
  },
  {
    title: "Puerto Rico",
    value: "PR",
  },
  {
    title: "Katar",
    value: "QA",
  },
  {
    title: "Kongo",
    value: "CG",
  },
  {
    title: "Réunion",
    value: "RE",
  },
  {
    title: "Rumänien",
    value: "RO",
  },
  {
    title: "Russland",
    value: "RU",
  },
  {
    title: "Ruanda",
    value: "RW",
  },
  {
    title: "Sankt Kitts und Nevis",
    value: "KN",
  },
  {
    title: "Sankt Lucia",
    value: "LC",
  },
  {
    title: "Sankt Martin",
    value: "MF",
  },
  {
    title: "Sankt Pierre und Miquelon",
    value: "PM",
  },
  {
    title: "Sankt Vincent und die Grenadinen",
    value: "VC",
  },
  {
    title: "Samoa",
    value: "WS",
  },
  {
    title: "San Marino",
    value: "SM",
  },
  {
    title: "São Tomé und Príncipe",
    value: "ST",
  },
  {
    title: "Saudi-Arabien",
    value: "SA",
  },
  {
    title: "Senegal",
    value: "SN",
  },
  {
    title: "Serbien",
    value: "RS",
  },
  {
    title: "Seychellen",
    value: "SC",
  },
  {
    title: "Sierra Leone",
    value: "SL",
  },
  {
    title: "Singapur",
    value: "SG",
  },
  {
    title: "Sint Maarten",
    value: "SX",
  },
  {
    title: "Slowakei",
    value: "SK",
  },
  {
    title: "Slowenien",
    value: "SI",
  },
  {
    title: "Salomonen",
    value: "SB",
  },
  {
    title: "Somalia",
    value: "SO",
  },
  {
    title: "Südafrika",
    value: "ZA",
  },
  {
    title: "Südkorea",
    value: "KR",
  },
  {
    title: "Südsudan",
    value: "SS",
  },
  {
    title: "Spanien",
    value: "ES",
  },
  {
    title: "Sri Lanka",
    value: "LK",
  },
  {
    title: "Sudan",
    value: "SD",
  },
  {
    title: "Suriname",
    value: "SR",
  },
  {
    title: "Swasiland",
    value: "SZ",
  },
  {
    title: "Schweden",
    value: "SE",
  },
  {
    title: "Schweitz",
    value: "CH",
  },
  {
    title: "Syrien",
    value: "SY",
  },
  {
    title: "Taiwan",
    value: "TW",
  },
  {
    title: "Tadschikistan",
    value: "TJ",
  },
  {
    title: "Tansania",
    value: "TZ",
  },
  {
    title: "Thailand",
    value: "TH",
  },
  {
    title: "Togo",
    value: "TG",
  },
  {
    title: "Tonga",
    value: "TO",
  },
  {
    title: "Trinidad und Tobago",
    value: "TT",
  },
  {
    title: "Tunesien",
    value: "TN",
  },
  {
    title: "Türkei",
    value: "TR",
  },
  {
    title: "Turkmenistan",
    value: "TM",
  },
  {
    title: "Turks- und Caicosinseln",
    value: "TC",
  },
  {
    title: "Tuvalu",
    value: "TV",
  },
  {
    title: "Amerikanische Jungferninseln",
    value: "VI",
  },
  {
    title: "Uganda",
    value: "UG",
  },
  {
    title: "Ukraine",
    value: "UA",
  },
  {
    title: "Vereinigte Arabische Emirate",
    value: "AE",
  },
  {
    title: "Vereinigtes Königreich",
    value: "GB",
  },
  {
    title: "USA",
    value: "US",
  },
  {
    title: "Uruguay",
    value: "UY",
  },
  {
    title: "Usbekistan",
    value: "UZ",
  },
  {
    title: "Vanuatu",
    value: "VU",
  },
  {
    title: "Venezuela",
    value: "VE",
  },
  {
    title: "Vietnam",
    value: "VN",
  },
  {
    title: "Westsahara",
    value: "EH",
  },
  {
    title: "Jemen",
    value: "YE",
  },
  {
    title: "Sambia",
    value: "ZM",
  },
  {
    title: "Simbabwe",
    value: "ZW",
  },
];

export const COUNTRIES = [
  {
    title: "Afghanistan",
    value: "AF",
  },
  {
    title: "Albania",
    value: "AL",
  },
  {
    title: "Algeria",
    value: "DZ",
  },
  {
    title: "American Samoa",
    value: "AS",
  },
  {
    title: "Andorra",
    value: "AD",
  },
  {
    title: "Angola",
    value: "AO",
  },
  {
    title: "Anguilla",
    value: "AI",
  },
  {
    title: "Argentina",
    value: "AR",
  },
  {
    title: "Armenia",
    value: "AM",
  },
  {
    title: "Aruba",
    value: "AW",
  },
  {
    title: "Australia",
    value: "AU",
  },
  {
    title: "Azerbaijan",
    value: "AZ",
  },
  {
    title: "Bahamas",
    value: "BS",
  },
  {
    title: "Bahrain",
    value: "BH",
  },
  {
    title: "Bangladesh",
    value: "BD",
  },
  {
    title: "Barbados",
    value: "BB",
  },
  {
    title: "Belarus",
    value: "BY",
  },
  {
    title: "Belgium",
    value: "BE",
  },
  {
    title: "Belize",
    value: "BZ",
  },
  {
    title: "Benin",
    value: "BJ",
  },
  {
    title: "Bermuda",
    value: "BM",
  },
  {
    title: "Bhutan",
    value: "BT",
  },
  {
    title: "Bolivia",
    value: "BO",
  },
  {
    title: "Bosnia and Herzegovina",
    value: "BA",
  },
  {
    title: "Botswana",
    value: "BW",
  },
  {
    title: "Brazil",
    value: "BR",
  },
  {
    title: "British Virgin Islands",
    value: "VG",
  },
  {
    title: "Brunei",
    value: "BN",
  },
  {
    title: "Bulgaria",
    value: "BG",
  },
  {
    title: "Burkina Faso",
    value: "BF",
  },
  {
    title: "Burundi",
    value: "BI",
  },
  {
    title: "Cambodia",
    value: "KH",
  },
  {
    title: "Cameroon",
    value: "CM",
  },
  {
    title: "Canada",
    value: "CA",
  },
  {
    title: "Cape Verde",
    value: "CV",
  },
  {
    title: "Cayman Islands",
    value: "KY",
  },
  {
    title: "Central African Republic",
    value: "CF",
  },
  {
    title: "Chad",
    value: "TD",
  },
  {
    title: "Chile",
    value: "CL",
  },
  {
    title: "China",
    value: "CN",
  },
  {
    title: "Columbia",
    value: "CO",
  },
  {
    title: "Comoros",
    value: "KM",
  },
  {
    title: "Cook Islands",
    value: "CK",
  },
  {
    title: "Costa Rica",
    value: "CR",
  },
  {
    title: "Croatia",
    value: "HR",
  },
  {
    title: "Cuba",
    value: "CU",
  },
  {
    title: "Curacao",
    value: "CW",
  },
  {
    title: "Cyprus",
    value: "CY",
  },
  {
    title: "Czech Republic",
    value: "CZ",
  },
  {
    title: "Democratic Republic of the Congo",
    value: "CD",
  },
  {
    title: "Denmark",
    value: "DK",
  },
  {
    title: "Djibouti",
    value: "DJ",
  },
  {
    title: "Dominica",
    value: "DM",
  },
  {
    title: "Dominican Republic",
    value: "DO",
  },
  {
    title: "East Timor",
    value: "TL",
  },
  {
    title: "Ecuador",
    value: "EC",
  },
  {
    title: "Egypt",
    value: "EG",
  },
  {
    title: "El Salvador",
    value: "SV",
  },
  {
    title: "Eritrea",
    value: "ER",
  },
  {
    title: "Estonia",
    value: "EE",
  },
  {
    title: "Faroe Islands",
    value: "FO",
  },
  {
    title: "Fiji",
    value: "FJ",
  },
  {
    title: "Finland",
    value: "FI",
  },
  {
    title: "France",
    value: "FR",
  },
  {
    title: "French Polynesia",
    value: "PF",
  },
  {
    title: "Gabon",
    value: "GA",
  },
  {
    title: "Gambia",
    value: "GM",
  },
  {
    title: "Georgia",
    value: "GE",
  },
  {
    title: "Germany",
    value: "DE",
  },
  {
    title: "Ghana",
    value: "GH",
  },
  {
    title: "Greece",
    value: "GR",
  },
  {
    title: "Greenland",
    value: "GL",
  },
  {
    title: "Grenada",
    value: "GD",
  },
  {
    title: "Guam",
    value: "GU",
  },
  {
    title: "Guatemala",
    value: "GT",
  },
  {
    title: "Guernsey",
    value: "GG",
  },
  {
    title: "Guinea",
    value: "GN",
  },
  {
    title: "Guinea-Bissau",
    value: "GW",
  },
  {
    title: "Guyana",
    value: "GY",
  },
  {
    title: "Haiti",
    value: "HT",
  },
  {
    title: "Honduras",
    value: "HN",
  },
  {
    title: "Hong Kong",
    value: "HK",
  },
  {
    title: "Hungary",
    value: "HU",
  },
  {
    title: "Iceland",
    value: "IS",
  },
  {
    title: "India",
    value: "IN",
  },
  {
    title: "Indonesia",
    value: "ID",
  },
  {
    title: "Iran",
    value: "IR",
  },
  {
    title: "Iraq",
    value: "IQ",
  },
  {
    title: "Ireland",
    value: "IE",
  },
  {
    title: "Isle of Man",
    value: "IM",
  },
  {
    title: "Israel",
    value: "IL",
  },
  {
    title: "Italy",
    value: "IT",
  },
  {
    title: "Ivory Coast",
    value: "CI",
  },
  {
    title: "Jamaica",
    value: "JM",
  },
  {
    title: "Japan",
    value: "JP",
  },
  {
    title: "Jersey",
    value: "JE",
  },
  {
    title: "Jordan",
    value: "JO",
  },
  {
    title: "Kazakhstan",
    value: "KZ",
  },
  {
    title: "Kenya",
    value: "KE",
  },
  {
    title: "Kiribati",
    value: "KI",
  },
  {
    title: "Kosovo",
    value: "XK",
  },
  {
    title: "Kuwait",
    value: "KW",
  },
  {
    title: "Kyrgyzstan",
    value: "KG",
  },
  {
    title: "Laos",
    value: "LA",
  },
  {
    title: "Latvia",
    value: "LV",
  },
  {
    title: "Lebanon",
    value: "LB",
  },
  {
    title: "Lesotho",
    value: "LS",
  },
  {
    title: "Liberia",
    value: "LB",
  },
  {
    title: "Libya",
    value: "LY",
  },
  {
    title: "Liechtenstein",
    value: "LI",
  },
  {
    title: "Lithuania",
    value: "LT",
  },
  {
    title: "Luxembourg",
    value: "LU",
  },
  {
    title: "Macau",
    value: "MO",
  },
  {
    title: "Macedonia",
    value: "MK",
  },
  {
    title: "Madagascar",
    value: "MG",
  },
  {
    title: "Malawi",
    value: "MW",
  },
  {
    title: "Malaysia",
    value: "MY",
  },
  {
    title: "Maldives",
    value: "MV",
  },
  {
    title: "Mali",
    value: "ML",
  },
  {
    title: "Malta",
    value: "MT",
  },
  {
    title: "Marshall Islands",
    value: "MH",
  },
  {
    title: "Mauritania",
    value: "MR",
  },
  {
    title: "Mauritius",
    value: "MU",
  },
  {
    title: "Mayotte",
    value: "YT",
  },
  {
    title: "Mexico",
    value: "MX",
  },
  {
    title: "Micronesia",
    value: "FM",
  },
  {
    title: "Moldova",
    value: "MD",
  },
  {
    title: "Monaco",
    value: "MC",
  },
  {
    title: "Mongolia",
    value: "MN",
  },
  {
    title: "Montenegro",
    value: "ME",
  },
  {
    title: "Morocco",
    value: "MA",
  },
  {
    title: "Mozambique",
    value: "MZ",
  },
  {
    title: "Myanmar",
    value: "MM",
  },
  {
    title: "Namibia",
    value: "NA",
  },
  {
    title: "Nepal",
    value: "NP",
  },
  {
    title: "Netherlands",
    value: "NL",
  },
  {
    title: "Netherlands Antilles",
    value: "AN",
  },
  {
    title: "New Caledonia",
    value: "NC",
  },
  {
    title: "New Zealand",
    value: "NZ",
  },
  {
    title: "Nicaragua",
    value: "NI",
  },
  {
    title: "Niger",
    value: "NE",
  },
  {
    title: "Nigeria",
    value: "NG",
  },
  {
    title: "North Korea",
    value: "KP",
  },
  {
    title: "Northern Mariana Islands",
    value: "MP",
  },
  {
    title: "Norway",
    value: "NO",
  },
  {
    title: "Oman",
    value: "OM",
  },
  {
    title: "Pakistan",
    value: "PK",
  },
  {
    title: "Palestine",
    value: "PS",
  },
  {
    title: "Panama",
    value: "PA",
  },
  {
    title: "Papua New Guinea",
    value: "PG",
  },
  {
    title: "Paraguay",
    value: "PY",
  },
  {
    title: "Peru",
    value: "PE",
  },
  {
    title: "Philippines",
    value: "PH",
  },
  {
    title: "Poland",
    value: "PL",
  },
  {
    title: "Portugal",
    value: "PT",
  },
  {
    title: "Puerto Rico",
    value: "PR",
  },
  {
    title: "Qatar",
    value: "QA",
  },
  {
    title: "Republic of the Congo",
    value: "CG",
  },
  {
    title: "Reunion",
    value: "RE",
  },
  {
    title: "Romania",
    value: "RO",
  },
  {
    title: "Russia",
    value: "RU",
  },
  {
    title: "Rwanda",
    value: "RW",
  },
  {
    title: "Saint Kitts and Nevis",
    value: "KN",
  },
  {
    title: "Saint Lucia",
    value: "LC",
  },
  {
    title: "Saint Martin",
    value: "MF",
  },
  {
    title: "Saint Pierre and Miquelon",
    value: "PM",
  },
  {
    title: "Saint Vincent and the Grenadines",
    value: "VC",
  },
  {
    title: "Samoa",
    value: "WS",
  },
  {
    title: "San Marino",
    value: "SM",
  },
  {
    title: "Sao Tome and Principe",
    value: "ST",
  },
  {
    title: "Saudi Arabia",
    value: "SA",
  },
  {
    title: "Senegal",
    value: "SN",
  },
  {
    title: "Serbia",
    value: "RS",
  },
  {
    title: "Seychelles",
    value: "SC",
  },
  {
    title: "Sierra Leone",
    value: "SL",
  },
  {
    title: "Singapore",
    value: "SG",
  },
  {
    title: "Sint Maarten",
    value: "SX",
  },
  {
    title: "Slovakia",
    value: "SK",
  },
  {
    title: "Slovenia",
    value: "SI",
  },
  {
    title: "Solomon Islands",
    value: "SB",
  },
  {
    title: "Somalia",
    value: "SO",
  },
  {
    title: "South Africa",
    value: "ZA",
  },
  {
    title: "South Korea",
    value: "KR",
  },
  {
    title: "South Sudan",
    value: "SS",
  },
  {
    title: "Spain",
    value: "ES",
  },
  {
    title: "Sri Lanka",
    value: "LK",
  },
  {
    title: "Sudan",
    value: "SD",
  },
  {
    title: "Suriname",
    value: "SR",
  },
  {
    title: "Swaziland",
    value: "SZ",
  },
  {
    title: "Sweden",
    value: "SE",
  },
  {
    title: "Switzerland",
    value: "CH",
  },
  {
    title: "Syria",
    value: "SY",
  },
  {
    title: "Taiwan",
    value: "TW",
  },
  {
    title: "Tajikistan",
    value: "TJ",
  },
  {
    title: "Tanzania",
    value: "TZ",
  },
  {
    title: "Thailand",
    value: "TH",
  },
  {
    title: "Togo",
    value: "TG",
  },
  {
    title: "Tonga",
    value: "TO",
  },
  {
    title: "Trinidad and Tobago",
    value: "TT",
  },
  {
    title: "Tunisia",
    value: "TN",
  },
  {
    title: "Turkey",
    value: "TR",
  },
  {
    title: "Turkmenistan",
    value: "TM",
  },
  {
    title: "Turks and Caicos Islands",
    value: "TC",
  },
  {
    title: "Tuvalu",
    value: "TV",
  },
  {
    title: "U.S. Virgin Islands",
    value: "VI",
  },
  {
    title: "Uganda",
    value: "UG",
  },
  {
    title: "Ukraine",
    value: "UA",
  },
  {
    title: "United Arab Emirates",
    value: "AE",
  },
  {
    title: "United Kingdom",
    value: "GB",
  },
  {
    title: "United States",
    value: "US",
  },
  {
    title: "Uruguay",
    value: "UY",
  },
  {
    title: "Uzbekistan",
    value: "UZ",
  },
  {
    title: "Vanuatu",
    value: "VU",
  },
  {
    title: "Venezuela",
    value: "VE",
  },
  {
    title: "Vietnam",
    value: "VN",
  },
  {
    title: "Western Sahara",
    value: "EH",
  },
  {
    title: "Yemen",
    value: "YE",
  },
  {
    title: "Zambia",
    value: "ZM",
  },
  {
    title: "Zimbabwe",
    value: "ZW",
  },
];
